<template>
  <div class="wrapper">
    <div class="container">
      <v-form ref="form" v-model="valid" @submit.prevent="submitForm">
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="formData.happinessCategoryTipsName"
              :label="'*' + $t('tips.label.form.categoryName')"
              :rules="categoryNameRules"
              :outlined="false"
              :filled="false"
              :solo="false"
              required
              :counter="50"
              :maxlength="50"
              class="linea-inferior-pura"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-select
              v-model="formData.status"
              :label="$t('tips.label.form.status')"
              :items="listStatus"
              item-text="nameStatus"
              item-value="valueStatus"
              :outlined="false"
              :filled="false"
              :solo="false"
              required
              class="linea-inferior-pura"
            ></v-select>
          </v-col>
        </v-row>


      </v-form>
    </div>
    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          fixed
          bottom
          right
          dark
          large
          color="primary"
          v-bind="attrs"
          v-on="on"
          @click="submitForm"
        >
          <v-icon dark>mdi-content-save</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('button.save') }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import EventBus from "@/utils/event_bus.js";
import i18n from '@/plugins/i18n';

import {
  TIPS_M,
  GET_TIPS,
  ACTION_POST_CREATE_TIPS,
} from "@/views/tips-categories/store/types/types.js";

export default {
  name: "formAddTipsComponent",
  data() {
    return {
      valid: false,
      formData: {
        happinessCategoryTipsName: "",
        status: true,
      },
      listStatus: [
        {
          idStatus: 1,
          nameStatus: this.$t('novelties.label.status.option1'),
          valueStatus: true
        },
        {
          idStatus: 2,
          nameStatus: this.$t('novelties.label.status.option2'),
          valueStatus: false
        }
      ],
      categoryNameRules: [
        (v) => !!v || i18n.t('tips.label.form.categoryNameRequired'),
        (v) => (v && v.length >= 3) || i18n.t('tips.label.form.categoryNameMinLength'),
        (v) => (v && v.length <= 50) || i18n.t('tips.label.form.categoryNameMaxLength'),
        (v) => !this.tips.some(t => t.happinessCategoryTipsName && t.happinessCategoryTipsName.toLowerCase() === v.toLowerCase()) || i18n.t('tips.label.form.categoryNameDuplicate'),
      ],
    };
  },
  computed: {
    ...mapGetters({
      tips: `${TIPS_M}${GET_TIPS}`,
    }),
  },
  methods: {
    ...mapActions({
      postActionTips: `${TIPS_M}${ACTION_POST_CREATE_TIPS}`,
    }),

    async submitForm() {
      if (this.$refs.form.validate()) {
        try {
          await this.postActionTips(this.formData);
          EventBus.$emit('formTips-submitted-successfully');
          this.$refs.form.reset();
        } catch (error) {
          console.error("Error al crear tip:", error);
        }
      }
    },
  },
  mounted() {
    EventBus.$on('clear-tips-form', () => {
      this.$refs.form.reset();
    });
  },
};
</script>

<style lang="css" scoped>
.wrapper {
  min-height: 100vh;
  width: 100%;
}

.container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.linea-inferior-pura ::v-deep fieldset {
  display: none !important;
  border: none !important;
}

.linea-inferior-pura ::v-deep .v-input__slot {
  background-color: transparent !important;
  box-shadow: none !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.42) !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-radius: 0px !important;
}

.linea-inferior-pura.v-input--is-focused ::v-deep .v-input__slot {
  border-bottom: 2px solid #6e17a5 !important;
}
</style>
